import { useTranslation } from 'react-i18next';
import { ReactSVG } from 'react-svg';
import downloadIcon from '@web/utils/src/assets/icons/functions/download-icon.svg';
import pdfIcon from '@web/utils/src/assets/icons/functions/pdf-icon.svg';
import { DocumentType } from '@/types';

interface Document {
  url: string;
  type: DocumentType;
  id: string;
}

interface InvoiceDocumentProps {
  documents: Document[];
}

const InvoiceDocuments: React.FC<InvoiceDocumentProps> = (props) => {
  const { documents } = props;

  const { t } = useTranslation();
  const HandleDocumentDownload = (url: string) => {
    window.open(url, '_blank');
  };
  return (
    <div>
      <p className="font-bd mb-1-0">{t('invoices.title')}</p>
      <div className="grid grid-cols-1 gap-1-6">
        {documents.map((document) => (
          <div
            key={document.id}
            className="p-1-6 rounded-8-0 border-2 border-secondary-grey"
          >
            <div className="flex items-center mb-1-6">
              <ReactSVG src={pdfIcon} className="mr-1-6" />
              {t('invoices.invoice')}
            </div>
            <div
              className="flex justify-between items-center md:text-1-3 text-1-6 cursor-pointer"
              onClick={() => HandleDocumentDownload(document.url)}
            >
              <p>{t('orders.download')}</p>
              <ReactSVG
                src={downloadIcon}
                className="download-icon text-white"
              />
            </div>
          </div>
        ))}
        {documents.length === 0 && (
          <p className="text-1-2">{t('orders.documents_not_found')}</p>
        )}
      </div>
    </div>
  );
};

export default InvoiceDocuments;
